export default {
  NMS_getrennt: {
    d: 'M -1,0 A 1,1 0 1 0 1,0 1,1 0 1 0 -1,0',
    fill: '#e57d1d',
    label: 'NMS: getrennt',
    order: 0,
  },
  NMS_verschr: {
    d: 'M -1,0 A 1,1 0 1 0 1,0 1,1 0 1 0 -1,0',
    fill: '#dedb00',
    label: 'NMS: verschränkt',
    order: 1,
  },
  NMS_nein: {
    d: 'M -1,0 A 1,1 0 1 0 1,0 1,1 0 1 0 -1,0',
    fill: '#9c9e9f',
    label: 'NMS: keine Nachmittagsbetreuung',
    order: 2,
  },
  ASO_getrennt: {
    d: 'm -1,1 2,0 0,-2 -2,0 z',
    fill: '#7f3489',
    label: 'Sonderschule: getrennt',
    order: 3,
  },
  AHS_ja: {
    d:
      'M 0,-1 0.3,-0.3 1,-0.2 0.5,0.3 0.7,1 0,0.6 -0.7,1 -0.5,0.3 -1,-0.2 -0.3,-0.3 Z',
    fill: '#41a62a',
    label: 'AHS Unterstufe: Nachmittagsbetreuung',
    order: 4,
  },
  AHS_nein: {
    d:
      'M 0,-1 0.3,-0.3 1,-0.2 0.5,0.3 0.7,1 0,0.6 -0.7,1 -0.5,0.3 -1,-0.2 -0.3,-0.3 Z',
    fill: '#9c9e9f',
    label: 'AHS Unterstufe: keine Nachmittagsbetreuung',
    order: 5,
  },
  poly_ja: {
    d: 'M -1.16,-1 1.16,-1 0,1 Z',
    fill: '#29a7e5',
    label: 'Polytechnische Schule: Nachmittagsbetreuung',
    order: 6,
  },
  poly_nein: {
    d: 'M -1.16,-1 1.16,-1 0,1 Z',
    fill: '#9c9e9f',
    label: 'Polytechnische Schule: keine Nachmittagsbetreuung',
    order: 7,
  },
}



// WEBPACK FOOTER //
// ./src/data/symbols_facility_10_14.js